<section id="about">
    <div class="container">
        <div class="row">
            <div class="col-12">
                <h1>Introduction to Fees</h1>
            </div>
        </div>
    </div>
  </section>

  <section class="section">
    <div class="container">
      <div class="row">
        <div class="col-sm-12">
          <p>Investing for Catholics, a division of Index Fund Advisors, Inc. a fee-only Registered Investment Adviser. Our account minimum is $100,000. We will provide our ADV Part 2 and client agreement prior to you becoming a client.</p>

          <h3>Investing for Catholics Management Fee</h3>

          <div >
              <app-script-trusted [src]="'//data.ifa.com/charts/embed/213/'"></app-script-trusted>
          </div>

          <div>
            <h2 style="margin-bottom:5px !important;">Tiered Fee Schedule Calculator:</h2>
            <div  style="max-width:900px">
            <app-fee-schedule [initialBalance]="1000000" [showDiscount]="false"></app-fee-schedule>
            </div>
          </div>

          <div class="clearfix mb-5"></div>

          <h3>Mutual Fund Fees</h3>

          <div>
              <app-script-trusted [src]="'//data.ifa.com/charts/embed/194/'"></app-script-trusted>
          </div>

          <div class="clearfix mb-5"></div>

          <div>
              <app-script-trusted [src]="'//data.ifa.com/charts/embed/186/'"></app-script-trusted>
          </div>

          <div class="clearfix mb-5"></div>

          <div>
              <app-script-trusted [src]="'//data.ifa.com/charts/embed/187/'"></app-script-trusted>
          </div>

          <div class="clearfix mb-5"></div>

          <div>
              <app-script-trusted [src]="'//data.ifa.com/charts/embed/193/'"></app-script-trusted>
          </div>

          <div class="clearfix mb-5"></div>

        </div>
        
        </div>
      </div>
  </section>